module.exports = __webpack_public_path__ + "assets/img/17_1793_big.0362111f.jpg";